import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { authAPI } from '@/api/auth'

interface ImpersonationState {
  impersonatedOrgId: string | null
  impersonatedOrgName: string | null

  /** Start impersonation — POST /auth/impersonate */
  startImpersonation: (orgId: string, orgName: string) => Promise<void>

  /** Stop impersonation — POST /auth/stop-impersonation */
  stopImpersonation: () => Promise<void>
}

export const useImpersonationStore = create<ImpersonationState>()(
  persist(
    (set) => ({
      impersonatedOrgId: null,
      impersonatedOrgName: null,

      startImpersonation: async (orgId, orgName) => {
        await authAPI.impersonate(orgId)
        set({ impersonatedOrgId: orgId, impersonatedOrgName: orgName })
      },

      stopImpersonation: async () => {
        await authAPI.stopImpersonation()
        set({ impersonatedOrgId: null, impersonatedOrgName: null })
      },
    }),
    {
      name: 'medcifra-impersonation',
      partialize: (state) => ({
        impersonatedOrgId: state.impersonatedOrgId,
        impersonatedOrgName: state.impersonatedOrgName,
      }),
    }
  )
)
